module.exports = __webpack_public_path__ + "static/media/11-mercedes.9e6d9762.jpg";